import type { BrowserTracker } from '@snowplow/browser-tracker'
import { newTracker } from '@snowplow/browser-tracker'

/**
 * The tracker instance used as a singleton and
 * must be accessed via the `getOrCreateTracker` method.
 */

type getOrCreateTrackerParams = {
  collectorUrl: string
  isSnowplowEncodingDisabled: boolean
}

let tracker: BrowserTracker | null = null

function createTracker({
  collectorUrl,
  isSnowplowEncodingDisabled,
}: getOrCreateTrackerParams): BrowserTracker {
  return newTracker('sc_eu', collectorUrl, {
    appId: 'N26',
    platform: 'web',
    cookieSameSite: 'Lax',
    // to set cookies on .n26.com, .dev-n26.com, .staging-n26.com domains
    discoverRootDomain: true,
    // disable encoding on local and dev, so it's easier to debug payload
    ...(isSnowplowEncodingDisabled && { encodeBase64: false }),
  })
}

function getOrCreateTracker(params: getOrCreateTrackerParams): BrowserTracker {
  if (!tracker) {
    tracker = createTracker(params)
  }

  return tracker
}

export { getOrCreateTracker }
